@use "styles" as *;

.me-menu {
  position: fixed;
  inset: 0 auto 0 0;
  width: $menu-max-width;
  display: flex;
  flex-direction: column;
  z-index: 10300;
  background-color: $color-background-contrast;
  box-shadow: $box-shadow;

  &--animated {
    transition:
      visibility $transition-timing,
      transform $transition-timing;
  }

  &:not(&--active) {
    visibility: hidden;
    transform: translateX(-100%);
  }

  &__header {
    background-color: $color-background-contrast;
    box-shadow: $box-shadow;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > .me-headline {
      margin: space(4);
    }

    > .me-button {
      padding: space(4);

      i {
        width: 1em;
        line-height: 1;
        vertical-align: middle;
      }
    }
  }

  &__scroll-container {
    flex: 1 1 auto;
    overflow-y: scroll;
  }

  &__nav {
    padding: space(10, 4, 4);

    @include remove-first-and-last-child-margins();
  }
}
